"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEventDataToJSON = exports.GameEventDataFromJSONTyped = exports.GameEventDataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GameEventDataFromJSON(json) {
    return GameEventDataFromJSONTyped(json, false);
}
exports.GameEventDataFromJSON = GameEventDataFromJSON;
function GameEventDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'gameId': json['gameId'],
        'gameTitle': json['gameTitle'],
        'eventInfo': json['eventInfo'],
        'eventName': !(0, runtime_1.exists)(json, 'eventName') ? undefined : json['eventName'],
        'category': (0, _1.OWLogCategoryFromJSON)(json['category']),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.GameEventDataFromJSONTyped = GameEventDataFromJSONTyped;
function GameEventDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'gameId': value.gameId,
        'gameTitle': value.gameTitle,
        'eventInfo': value.eventInfo,
        'eventName': value.eventName,
        'category': (0, _1.OWLogCategoryToJSON)(value.category),
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.GameEventDataToJSON = GameEventDataToJSON;
